import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import PasswordForm from './PasswordForm';
import SocialAccounts from './SocialAccounts';
import LoginHistory from './LoginHistory';
import WithdrawForm from './WithdrawForm';

// 계정·보안 화면: 비밀번호 변경, 소셜 계정 연결, 로그인 기록, 회원 탈퇴를 항목별로 펼쳐 보여준다.
export default function AccountSection() {
    const { myPage } = useOutletContext();
    const [open, setOpen] = useState('');

    // 같은 항목을 다시 누르면 접고, 다른 항목을 누르면 그 항목만 펼친다.
    function toggle(name) {
        setOpen(previous => previous === name ? '' : name);
    }

    return <>
        <div className="my-page-section-heading"><div><h2>계정·보안</h2><p>비밀번호와 로그인 방식, 계정 상태를 관리합니다.</p></div></div>
        <ul className="my-page-card my-page-list">
            <li className={open === 'password' ? 'expanded' : undefined}>
                <div><h3>비밀번호 변경</h3><p>{myPage.hasPassword ? '현재 비밀번호 확인 후 새 비밀번호로 변경합니다.' : '소셜 로그인으로 가입한 계정은 비밀번호가 없습니다.'}</p></div>
                {myPage.hasPassword && open !== 'password' && <button type="button" className="my-page-button" onClick={() => toggle('password')}>변경하기</button>}
                {open === 'password' && <PasswordForm onCancel={() => toggle('password')} />}
            </li>
            <li className="expanded">
                <div><h3>소셜 계정 연결</h3><p>소셜 계정을 연결하면 해당 계정으로도 로그인할 수 있습니다.</p></div>
                <SocialAccounts socialAccounts={myPage.socialAccounts} hasPassword={myPage.hasPassword} />
            </li>
            <li className={open === 'history' ? 'expanded' : undefined}>
                <div className="my-page-list-title"><div><h3>로그인 기록</h3><p>최근 로그인한 일시, 방식, 기기를 확인합니다.</p></div>{open === 'history' && <button type="button" className="my-page-button" onClick={() => toggle('history')}>접기</button>}</div>
                {open === 'history' ? <LoginHistory /> : <button type="button" className="my-page-button" onClick={() => toggle('history')}>기록 보기</button>}
            </li>
            <li className={open === 'withdraw' ? 'expanded danger' : 'danger'}>
                <div><h3>회원 탈퇴</h3><p>탈퇴 시 계정이 비활성화되며 연습 기록과 피드백을 더 이상 확인할 수 없습니다.</p></div>
                {open === 'withdraw' ? <WithdrawForm hasPassword={myPage.hasPassword} onCancel={() => toggle('withdraw')} /> : <button type="button" className="my-page-button" onClick={() => toggle('withdraw')}>탈퇴하기</button>}
            </li>
        </ul>
    </>;
}
